<template>

    <div class='section'>

        <!-- only show search if project isnt specified -->
        <div v-if="this.project == null" class='section'>
            <b-input placeholder="Search..."
                type="search"
                icon="magnify"
                icon-clickable
                @icon-click="UpdateSearch"
                @keyup.native.enter="UpdateSearch"
                v-model=searchquery>
            </b-input>
        </div>

        <b-table
            :per-page="perPage"
            :current-page.sync="page"
            :loading="loading"
            :focusable=false
            :striped=true
            :data="data"
            :paginated="isPaginated"
            backend-pagination
            :total="total"

            @page-change="onPageChange"

            backend-sorting
            :default-sort-direction="defaultSortOrder"
            :default-sort="[sortField, sortOrder]"
            @sort="onSort">
        >

            <template slot-scope="props">
               
                <!-- bind sortable attribute so it can be disabled "v-bind:sortable="sortable" -->
                <b-table-column field="name" label="name" v-bind:sortable="sortable">
                    <router-link :to="{ name: 'project', params: {project: props.row.name} }">
                        {{ props.row.name }}
                        <b-icon
                            icon="open-in-new"
                            size="is-small">
                        </b-icon>
                    </router-link>
                </b-table-column>

                <b-table-column field="shot_count" label="Shot Count" v-bind:sortable="sortable">
                        {{ props.row.shot_set.length }}
                </b-table-column>

                <b-table-column field="notes" label="Notes" v-bind:sortable="sortable">
                        {{ props.row.notes }}
                </b-table-column>

                <b-table-column field="director" label="Director" v-bind:sortable="sortable">
                        {{ props.row.director }}
                </b-table-column>

                <b-table-column field="agency" label="Agency" v-bind:sortable="sortable">
                        {{ props.row.agency }}
                </b-table-column>

                <b-table-column field="production_company" label="Production Company" v-bind:sortable="sortable">
                        {{ props.row.production_company }}
                </b-table-column>

                <b-table-column field="client" label="Client" v-bind:sortable="sortable">
                        {{ props.row.client }}
                </b-table-column>

                <b-table-column field="date_start" label="Start" v-bind:sortable="sortable">
                        {{ props.row.date_start | relative_day }}
                </b-table-column>

                <b-table-column field="date_end" label="End" v-bind:sortable="sortable">
                        {{ props.row.date_end | relative_day_in_weeks }}
                </b-table-column>

                <b-table-column field="resolution" label="Resolution" v-bind:sortable="sortable">
                        {{ props.row.resolution }}
                </b-table-column>

                <b-table-column field="fps" label="FPS" v-bind:sortable="sortable">
                        {{ props.row.fps }}
                </b-table-column>
            </template>
        </b-table>
    </div>

</template>


<script>
    import axios from 'axios'
    import { date_filters } from '../mixins/Filters'
    import { GetAxiosAuthConfig } from '../mixins/axiosAuth'

    export default {
        mixins: [date_filters, GetAxiosAuthConfig],

        // props have defaults, or allow overriding when using the component
        props: {
            paginated : {
                type: Boolean,
                default: true,
            },
            sortable : {
                type: Boolean,
                default: true,
            },
            project : {
                type: String,
                default: null,
            },
        },
        data () {
            return {
                data: [],
                loading: false,

                perPage: 18, // 18 fits 24" monitor well
                total: 0,
                sortField: 'name',
                sortOrder: 'desc',
                defaultSortOrder: 'desc',
                page: 1,

                searchquery: '',

                // set initially from router
                query_fields: [
                    {
                        name: 'search',
                        query: this.$route.query.search,
                    },
                ],
            }
        },
        computed: {
            isPaginated: function () {
                // check if there are enough results that pagination buttons are needed
                return this.total > this.perPage
            }
        },
        methods: {
            loadAsyncData() {
                // create page offset
                let offset = this.perPage * (this.page-1)
                let sort = '';

                // create sort
                if (this.sortOrder == 'asc') {
                    sort = this.sortField
                }
                else {
                    sort = "-" + this.sortField
                }
                // create rest url based on page
                let resturl = window.location.origin + '/api/projects/?format=json&limit=' + this.perPage + '&offset=' + offset + '&ordering=' + sort
                
                // if a project is specified then limit the request
                if (this.project != null) {
                    resturl += '&name=' + this.project
                }

                // apply queries
                this.query_fields.forEach(function(field) {
                    if (field.query) {
                        resturl += '&' + field.name + '=' + field.query
                    }
                })

                this.loading = true

                console.log('projects resturl', resturl)

                axios.get(resturl, axios_auth_config)
                    .then(response => {
                     
                        // empty data
                        this.data = []
                        this.total = response.data.count
                        this.data = response.data.results
                        this.loading = false
                    })
                    .catch(error => console.log(error))
            },
            onPageChange(page) {
                this.page = page
                this.loadAsyncData()
            },
            onSort(field, order) {
                this.sortField = field
                this.sortOrder = order
                this.loadAsyncData()
            },
            UpdateQuery(field, value) {
                // change the router query, and change the data

                // append router query
                this.$router.push({
                    query: {
                        ...this.$route.query,
                        [field]: value
                    }
                })

                // get which query key was changed
                this.query_fields.forEach(function(query_field) {
                    
                    // update the queryfield with the value
                    if (query_field.name == field) {
                        query_field.query = value
                    }
                })

                this.loadAsyncData()
            },
            ResetQuery(query_key) {
                // change the router query, and change the data

                // append router query
                this.$router.replace({
                    query: {
                        ...this.$route.query,
                        [query_key]: null
                    }
                })

                // get which query key was changed
                this.query_fields.forEach(function(query_field) {
                    
                    if (query_field.name == query_key) {
                        // reset to null
                        query_field.query = null
                    }
                })

                // reload data
                this.loadAsyncData()
            },
            UpdateSearch() {
                this.UpdateQuery('search', this.searchquery)
            }
        },
        filters: {
            // Filter to truncate string, accepts a length parameter
            truncate(value, length) {
                return value.length > length
                    ? value.substr(0, length) + '...'
                    : value
            }
        },
        mounted() {
            this.loadAsyncData()
        }
    }

</script>
